import { inject, Injectable }                                                        from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable }                                                                from 'rxjs';
import { map }                                                                       from 'rxjs/operators';
import { SessionService }                                                            from '../../../api/session/session.service';
import { InternalRoutes }                                                            from '../../../shared/data/internal-routes';

@Injectable({
  providedIn: 'root'
})
export class ShareAccessDisabledGuard implements CanActivate {
  private router = inject(Router);
  private sessionService = inject(SessionService);

  canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.isShareAccessAllowed();
  }

  private isShareAccessAllowed(): Observable<boolean | UrlTree> {
    return this.sessionService.loadSession().pipe(map(data => {
      const hasRightToShare = data.hasCustomerLevelAccess && data.agentsFeatureEnabled;
      return hasRightToShare ? true : this.router.parseUrl(InternalRoutes.ERROR);
    }));
  }
}
